<template>

        <Drop v-if="tasks"
              :style="'min-height: ' + minh + 'px; max-height: ' + maxh + 'px;'"
              @drop="moveLocationItem"
        >
        <Drag
              :transferData="{
                location: location
             }"
        >

                    <div class="dev-priorities-ideas"
                      :class="{ 'flex-start': cols == 3 }">
                      <ColTask v-for="(task, $taskIndex) of tasks"
                                  :key="$taskIndex"
                                  :task="task"
                                  :taskIndex="$taskIndex"
                                  :section="section"
                                  :cols="cols"
                                  :column="section"
                                  :columnIndex="section"
                                  :board="board"
                                  :location="location"
                                  :location_set="location_set"
                      />


                        <div class="cards-edit-box"  v-if="!enableExtraClick"
                            :class="{ 'w33': cols === 3 }">
                            <div class="edit-cards-start">
                            <textarea class="board-cart-textarea" placeholder="Card Title"
                                      ref="taskName"
                                      autofocus
                                      @keyup.enter="$event.target.blur()"
                                      @blur="createTask($event, tasks)"
                                      @keyup.esc="enableExtraClick = true"
                            ></textarea>
                            </div>
                        </div>

                        <div class="board-add-card"
                             :class="{ 'w33': cols === 3 }"
                             v-else>
                            <a  @click="addNewTaskTx()">
                                <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill="#6E7077" d="M12 24C5.383 24 0 18.617 0 12S5.383 0 12 0s12 5.383 12 12-5.383 12-12 12zm0-22C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm5 11H7a1 1 0 010-2h10a1 1 0 110 2zm-5 5a1 1 0 01-1-1V7a1 1 0 012 0v10a1 1 0 01-1 1z"/>
                                </svg>
                                <span class="ml-2">Add a Card</span>
                            </a>
                        </div>

                    </div>
        </Drag>
    </Drop>

</template>

<script>
import MovingDataPlannerItems from "../../mixins/MovingDataPlannerItems";
import BacklogTask from "./BacklogTask";
import Drop from "./Drop";
import Drag from "./Drag";
import ColTask from "./ColTask";

export default {
    name: "BackLog",
    props: ['tasks', 'section', 'cols', 'minh', 'maxh', 'count', 'column', 'columnIndex', 'board','location', 'location_set'],
    mixins: [MovingDataPlannerItems],
    components: {BacklogTask, Drop, Drag, ColTask},
    data: () => {
        return {
            enableExtraClick: true,
            renameTitle: false,
        };
    },
    methods: {
        addNewTaskTx () {
            this.enableExtraClick = false;
            setTimeout(() => {
                this.$refs.taskName.focus()
            })
        },
        createTask (e, tasks) {
            if(e.target.value) {
                this.$store.commit('CREATE_TASK', {
                    tasks,
                    name: e.target.value,
                })
                e.target.value = ''

                this.enableExtraClick = true;
            } else {
                this.enableExtraClick = true;
                return false;
            }
        },
    }
}
</script>

<style scoped>

.align-center {
    margin: auto;
    width: 100%;
    padding: 10px;
}

.center a {
    margin: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

textarea {
    height: 42px;
}

.dev-priorities-ideas .cols-3 {
    /*justify-content: flex-start;*/
    /*flex-wrap: wrap;*/
    margin-right: 10px;
}

.cols-3 .cards-edit-box {
    width: calc(33% - 10px);
    margin-bottom: 30px;
    margin-right: 12px;
}

.w33 {
  width: calc(33% - 10px);
  margin-right: 10px;
}

.flex-start {
  justify-content: flex-start;
}
</style>
